function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.241 11.2199L14.8224 13.8008C15.1046 14.0829 15.1046 14.5403 14.8225 14.8224C14.5404 15.1045 14.083 15.1044 13.8009 14.8223L11.2201 12.2409C10.0697 13.163 8.63893 13.6646 7.16461 13.6625C3.57772 13.6625 0.666626 10.7514 0.666626 7.16449C0.666626 3.5776 3.57772 0.666504 7.16461 0.666504C10.7515 0.666504 13.6626 3.5776 13.6626 7.16449C13.6647 8.63881 13.1631 10.0696 12.241 11.2199ZM10.7926 10.6842C11.7089 9.74194 12.2207 8.47883 12.2186 7.16449C12.2186 4.3718 9.95657 2.1105 7.16461 2.1105C4.37192 2.1105 2.11062 4.3718 2.11062 7.16449C2.11062 9.95645 4.37192 12.2185 7.16461 12.2185C8.47895 12.2205 9.74206 11.7088 10.6843 10.7925L10.7926 10.6842Z"
});

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.277a1bd7.svg";
export { ForwardRef as ReactComponent };